import React, { useCallback } from 'react';
import { Box,  LargeCloseIcon, RawButton,Text } from '@common-fe/common-fe';

import { useFilesListFilterStore } from './stores';

const FileListDuplication = () => {
  const duplicationItem = useFilesListFilterStore((state) => state.duplicationItem);
  const setDuplicationItem = useFilesListFilterStore((state) => state.setDuplicationItem); 
  const handleClear = useCallback(() => {
    setDuplicationItem(null);
  }, [setDuplicationItem]);
  
  if(!duplicationItem || !duplicationItem.value) {
    return null;
  }
  return (
    <Box data-testid="file-list-duplication-filter" direction='row' align='center' margin={{top: 'spacing8', bottom: 'spacing24'}} >
      <Text size="medium" weight={700}>
        Search for duplicates of:
      </Text>
      <Box direction='row' width={{max: '500px'}} align='center' margin={{left: 'spacing4'}}>
        <Text data-testid="file-list-duplication-filter_text" size="medium" weight={400} truncate title={`${duplicationItem.value || ''}`}>
          {`${duplicationItem.value || ''}`}
        </Text>
        <RawButton data-testid="file-list-duplication-filter_close-button"  onClick={handleClear}>
          <Box width="24px" height="24px" align='center' justify='center'>
            <LargeCloseIcon size="18px" color="iconPrimary" />
          </Box>
        </RawButton>
      </Box>
    </Box>
  );
};

export default FileListDuplication;